import PoolDevice from "./base";
import { StatesToDisplayItem, DisplayProcessingLogics, DisplayWidths } from "../Types";
import { PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import { DeviceTypes } from "../../config/documents/HardwareConfig";


export default class PoolDeviceFlowSwitch extends PoolDevice implements PoolDeviceInterface {
    static CanBeAddedToflow = true;
    static DeviceType = DeviceTypes.FLOWSWITCH;
    static Icon = "flowsensor";
    static PickerTitle = Locale.gettext("Flow Sensor");

    getMainMetricField():StatesToDisplayItem {
        let order = 0;
        return {
            Name: PoolsideDaemonDeviceStateNames.State,
            DisplayName: "Sensor State",
            DisplayNameShort: "Sensor",
            DisplayOrder: ++order,
            DisplayProcessingLogic: DisplayProcessingLogics.ONOFF,
            DisplayProcessingLogicUnitAsDisplayName: false,
            DisplayWidth: DisplayWidths.WIDE
        };
    }    
}

export enum PoolsideDaemonDeviceStateNames {
    State = "State",
}
